export const getCookieOverrideValue = artifactId => {
  if (typeof document === 'undefined') {
    return null;
  }
  const wixStaticsVersionsCookie = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('wixStaticsVersions='));
  if (!wixStaticsVersionsCookie) {
    return null;
  }
  const cookieValue = wixStaticsVersionsCookie.split('=')[1].trim();
  const overrideArtifactEntry = cookieValue.split('|').find(overrideEntry => overrideEntry.startsWith(`${artifactId}#`));
  if (!overrideArtifactEntry) {
    return null;
  }
  return overrideArtifactEntry.split('#')[1];
};
//# sourceMappingURL=cookie-utils.js.map